let allowedCorpus = [
    'oeuvre',
    'ouvrage théorique',
    'oeuvres numériques',
    'oeuvres pré-numériques',
    'imaginaire du numérique'];

let allowedType = [
    'animation',
    'application',
    'article',
    'atlas',
    'bande dessinée',
    'bande dessinée numérique',
    'bande dessinée papier',
    'court métrage',
    'documentaire',
    'encyclopédie',
    'enquête',
    'essai',
    'exposition',
    'fiction interactive',
    'film',
    'guide',
    'illustration',
    'installation artistique',
    'jeu vidéo',
    'livre numérique',
    'livre papier',
    'mémoire',
    'monographie',
    'ouvrage collectif',
    'ouvrage de référence',
    'peinture',
    'périodique',
    'présentation',
    'roman graphique',
    'thèse'];

let allowedLanguages = [
    'allemand',
    'anglais',
    'arabe',
    'chinois',
    'coréen',
    'espagnol',
    'finnois',
    'français',
    'hindi',
    'inuktitut',
    'indonésien',
    'italien',
    'japonais',
    'latin',
    'néerlandais',
    'portugais',
    'russe',
    'serbe',
    'suédois',
    'thaï'];

let allowedMediaCharacteristics = [
    "animation",
    "enregistrement de voix",
    "environnement 3D",
    "illustration",
    "images animées",
    "localisation",
    "photogrammétrie",
    "photographies",
    "réalité augmentée",
    "réalité virtuelle",
    "son",
    "texte",
    "video"];

let allowedInteractions = [
    "activation de contenu",
    "déplacement physique",
    "déplacement/glissement de contenu",
    "interaction app. num./app. num.",
    "interaction livre/appareil numérique",
    "manipulation du livre papier",
    'navigation 3D - première personne',
    'navigation 3D - troisième personne',
    "navigation libre",
    "navigation linéaire",
    "navigation à choix multiples",
    "participatif de contenu",
    "rotation appareil"];

let allowedMedia = [
    "application - console",
    "application - ordinateur",
    "application - smartphone",
    "application - smartwatch",
    "application - tablette",
    "document",
    "installation",
    "objet physique",
    "papier",
    "canevas",
    "web"];

let availableThemes = [
    "affliction psychologique",
    "amour",
    "amour courtois",
    "bonheur",
    "curiosité",
    "douleur",
    "démesure",
    "exagération",
    "exploit chevaleresque",
    "gens en marges de la société",
    "humanité",
    "héros miséreux",
    "industrialisation",
    "irrégularité",
    "joie",
    "l'histoire",
    "liberté",
    "mort",
    "ouverture",
    "quête du savoir",
    "rationnalité",
    "recherche de la perfection",
    "ridicule",
    "science",
    "souffrance",
    "surcharge",
    "surnaturel",
    "transgression des limites",
    "trivialité",
    "vie",
    "vie vulgaire",
    "équilibre"];

let availableKeywords = [
	"arcs narratifs",
	"art",
	"arts visuels",
	"autoréflexivité",
	"aventure",
	"bibliothèque",
	"biographie",
	"calligramme",
	"casse-tête",
	"censure",
	"choix",
	"cinéma",
	"conte",
	"contraintes du support papier",
	"contrôle",
	"courriel",
	"court-métrage",
	"critique",
	"découverte",
	"dédoublement",
	"démocratie",
	"déplacement physique",
	"dépression",
	"design",
	"désorientation",
	"dialogue",
	"disparition",
	"documentaire",
	"données",
	"dystopie",
	"éclatement narratif",
	"éducation",
	"encyclopédie",
	"existence",
	"exploration",
	"fantastique",
	"fantasy",
	"féminisme",
	"feuilleton",
	"figure du livre",
	"folie",
	"génération textuelle",
	"géolocalisation",
	"guerre",
	"histoire",
	"histoire du livre",
	"horreur",
	"hyperlivre",
	"hypertexte",
	"identité",
	"image",
	"imaginaire du numérique",
	"imagination",
	"imprimerie",
	"installation artistique",
	"intelligence artificielle",
	"interactivité",
	"internet",
	"jeunesse",
	"journal intime",
	"lecture",
	"littérature",
	"magie",
	"maladie",
	"mémoire",
	"minimalisme",
	"moyen âge",
	"multimédia",
	"musée",
	"musique",
	"mystère",
	"mythologie",
	"narration",
	"narration combinatoire",
	"narration éclatée",
	"narration en temps réel",
	"nature",
	"nouvelles",
	"numérique",
	"objet artistique",
	"ordre",
	"peinture",
	"performance",
	"perte de contrôle",
	"philosophie",
	"poésie",
	"poésie combinatoire",
	"politique",
	"possession",
	"propriété",
	"prototype",
	"réalité augmentée",
	"réalité virtuelle",
	"récits combinatoires",
	"recueil",
	"remédiation",
	"reportage",
	"réseaux sociaux",
	"rêve",
	"roman graphique",
	"roman-feuilleton",
	"rupture",
	"santé mentale",
	"science-fiction",
	"sculpture",
	"secrets",
	"sensation",
	"supports de lecture",
	"surréalisme",
	"symbolisme",
	"technologie",
	"téléphone intelligent",
	"témoignage",
	"temps",
	"texto",
	"théâtre",
	"thriller",
	"trace",
	"transmédiatisation",
	"twitter",
	"typographie",
	"vidéoclip",
	"vie",
    "voyage"];

export {
    allowedCorpus,
    allowedInteractions,
    allowedLanguages,
    allowedMedia,
    allowedMediaCharacteristics,
    allowedType,
    availableThemes,
    availableKeywords
}